import lightMode from './logo-light-mode.svg';
import darkMode from './logo-dark-mode.svg';

import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';

/**
 * The full logo for DevHub.
 * @param height - The height of the logo.
 */
const LogoFull = ({ height = '40px' }: { height: string }) => {
  const themeRef = useApi(appThemeApiRef);
  const themeId = themeRef.getActiveThemeId();

  if (themeId === 'devhub-dark') {
    return <img src={darkMode} height={height} alt="DevHub" />;
  }

  return <img src={lightMode} height={height} alt="DevHub" />;
};

export default LogoFull;
